import { NgIf } from '@angular/common';
import {
  afterNextRender,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PrimeNGModule } from '../../../primeng.module';
import { AddressService } from '../../../services/address/address.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { ToastService } from '../../../services/toast/toast.service';
import { StorageConstants } from '../../models/storage/storage-constants';
import Address from '../../models/user/address';
import extractNumbers from '../../utils/extract-numbers';

@Component({
  selector: 'app-zip-code-input',
  standalone: true,
  imports: [NgIf, PrimeNGModule],
  templateUrl: './zip-code-input.component.html',
  styleUrl: './zip-code-input.component.scss',
})
export class ZipCodeInputComponent {
  @Output()
  public changed: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  public addressFound: EventEmitter<Address> = new EventEmitter<Address>();

  @Output()
  public zipcodeError: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public showKnowZipCoded: boolean = true;

  @Input()
  public emitterEventError: boolean = false;

  @Input()
  public placeholder: string = '';

  @Input()
  public readOnly?: boolean;

  @Input()
  public initSearch?: boolean = true;

  public errorInput?: boolean;
  public zipCode: string = '';

  constructor(
    private addressService: AddressService,
    private localStorageService: LocalStorageService,
    private toastService: ToastService
  ) {
    afterNextRender(() => {
      this.init();
    });
  }

  async init() {
    const zipCode = await this.localStorageService.get(
      StorageConstants.RM_ECOMMERCE_ZIP_CODE
    );

    if (zipCode) {
      this.zipCode = zipCode;

      if (this.initSearch) {
        this.getFullAddress(false);
      }
    }
  }

  async getFullAddress(showMsg: boolean) {
    const valueNumber = extractNumbers(this.zipCode);
    this.changed.emit(valueNumber);
    if (valueNumber?.length === 8) {
      try {
        const address: Address = await this.addressService.getAddress(
          valueNumber
        );
        this.localStorageService.set(
          StorageConstants.RM_ECOMMERCE_ZIP_CODE,
          valueNumber
        );
        this.addressFound.emit(address);
      } catch (error) {
        if (this.emitterEventError) {
          return this.zipcodeError.emit(true);
        } else {
          this.toastService.error('CEP não localizado!6');
        }
      }
    } else {
      this.localStorageService.removeItem(
        StorageConstants.RM_ECOMMERCE_ZIP_CODE
      );
      this.changed.emit(valueNumber);
      if (showMsg) {
        this.toastService.error('Digite um CEP válido para obter sua cotação!');
      }
    }
  }
}
